import { render, staticRenderFns } from "./FeesInsight.vue?vue&type=template&id=3e797a10&scoped=true"
import script from "./FeesInsight.vue?vue&type=script&lang=js"
export * from "./FeesInsight.vue?vue&type=script&lang=js"
import style0 from "./FeesInsight.vue?vue&type=style&index=0&id=3e797a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e797a10",
  null
  
)

export default component.exports